import { ActionTree } from 'vuex';
import { UndergradCourseState } from '@/store/undergrad/courses/state';
import RootState from '@/store/root_state';
import { normalize } from 'normalizr';
import { undergradCourse, undergradLives } from '@/store/undergrad/undergrad_api_normalizr_schema';
import { ErrorHandler } from '@/helpers/errorHandler';
import i18n from '@/i18n';
import { CoursesReaderService } from '@/services/undergrad/courses-reader.service';
import { UndergradCoursesInfo } from '@/models/undergrad/undergrad-courses.model';
import { StellateCoursesReaderService } from '@/services/undergrad/stellate/stellate-courses-reader.service';
import SentryClient from '@/helpers/sentry';

const actions: ActionTree<UndergradCourseState, RootState> = {
  async PULL_USER_UNDERGRAD_COURSES({ commit }) {
    try {
      const courseData = await CoursesReaderService.getCoursesByUserEnrollments();

      if (!courseData.length) {
        return;
      }

      const normalizedResponse = normalize(courseData, [undergradCourse]);

      commit('SET_UNDERGRAD_COURSES', normalizedResponse.entities);
    } catch (error) {
      ErrorHandler.showErrorMessage({
        error,
        customMessage: i18n.t('itWasNotPossibleRetrieveCourses').toString(),
      });
    }
  },
  // TODO: SWITCH_CURRENT_UNDERGRAD_COURSE - MUST BE FULLY IMPLEMENTED
  async SWITCH_CURRENT_UNDERGRAD_COURSE(
    { commit, dispatch, rootGetters },
    course: UndergradCoursesInfo,
  ) {
    commit('SET_SWITCHING_CURRENT_COURSE', true);
    // TODO: GET DEGREES INFO - DISPLAY DEGREES CARDS IN THE HOME PAGE
    // TODO: HOW THE KEEP STUDYING WILL WORKS NOW? GET DATA TO DISPLAY IN THE HOME PAGE
    // TODO: DEGREES AND KEEP STUDYING HAS PROGRESS - IT NEEDS TO BE IMPLEMENTED

    commit('SET_CURRENT_COURSE_ID', course.id);
    commit('SET_PROGRESS_OUTDATED', true);

    await dispatch('PULL_USER_DISCIPLINES_AND_CYCLES', course.id);

    await dispatch('GET_USER_MICROCERTIFICATES');

    dispatch('VERIFY_MICROCERTIFICATES_ELIGIBILITY', { courseId: course.id });

    dispatch('PULL_ACTIVE_STUDY_WINDOWS');

    if (rootGetters.shouldShowOnboardingV2) {
      dispatch('PULL_USER_PENDING_DOCS', course.id);
      dispatch('PULL_USER_CALENDAR');
    }

    commit('SET_STUDY_CALENDAR_EVENTS', { studyCalendarEvents: [] });
    commit('SET_IS_LOADING_STUDY_CALENDAR_EVENT_DATA', { isLoading: true });

    commit('SET_SWITCHING_CURRENT_COURSE', false);
  },

  async PULL_COURSE_LIVES({ commit }, course: UndergradCoursesInfo) {
    try {
      commit('SET_LOADING_COURSE_LIVES', { courseId: course.id, isLoading: true });

      const courseLives = await StellateCoursesReaderService.getLivesByCourseId(course.id);
      const normalizedResponse = normalize(courseLives, [undergradLives]);

      commit('SET_COURSE_LIVES', { courseId: course.id, entities: normalizedResponse.entities });
    } catch (error) {
      SentryClient.captureError(error);
    } finally {
      commit('SET_LOADING_COURSE_LIVES', { courseId: course.id, isLoading: false });
    }
  },
};

export default actions;
